import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { GroupEditResult, GroupList, UpdateGroupDto } from "src/app/_models/Group";
import { EditGroupStateActionTypes } from "src/app/constants/StoreConstants";

export const SetEditGroup = createAction(
  EditGroupStateActionTypes.SetEditGroup,
  props<{groupId: number}>()
);

export const SetEditGroupSuccess = createAction(
  EditGroupStateActionTypes.SetEditGroupSuccess,
  props<{group: GroupList}>()
);

export const SetEditGroupError = createAction(
  EditGroupStateActionTypes.SetEditGroupError,
  props<{error: HttpErrorResponse}>()
);

export const ResetEditGroup = createAction(
  EditGroupStateActionTypes.ResetEditGroup
);

export const EditGroup = createAction(
  EditGroupStateActionTypes.EditGroup,
  props<{dto: UpdateGroupDto}>()
);

export const EditGroupSuccess = createAction(
  EditGroupStateActionTypes.EditGroupSuccess, 
  props<{group: GroupEditResult}>()
);

export const EditGroupError = createAction(
  EditGroupStateActionTypes.EditGroupError,
  props<{error: HttpErrorResponse}>()
);  